import type { Payload as TooltipPayload } from "recharts/types/component/DefaultTooltipContent";
import { EMISSIONS_UNIT, formatNumberToTwoDecimals } from "../../modules/emissions/emissions-chart-utils";
import "./EmissionsChartTooltipBoxes.css";

type TooltipEntry = TooltipPayload<number, string>;

interface EmissionsChartTooltipBoxesProps {
    entries: TooltipEntry[];
    colorByAreaKey?: Record<string, string>;
}

export const EmissionsChartTooltipBoxes: React.FC<EmissionsChartTooltipBoxesProps> = ({ entries, colorByAreaKey }) => {
    return (
        <ul className="emissions-chart-tooltip-boxes">
            {entries.map((entry, idx) => {
                const numericValue = typeof entry.value === "number" ? entry.value : Number(entry.value ?? 0) || 0;
                const label = String(entry.name);
                const areaKey = String(entry.dataKey);
                return (
                    <li
                        key={(entry.dataKey as string) || idx}
                        className="emissions-chart-tooltip-boxes__item"
                        style={{
                            backgroundColor: colorByAreaKey?.[areaKey] || undefined,
                            // The "-nav-oN" fill tokens (colors.css) stay equally dark in both themes, so
                            // a literal white (not a theme-flipping token) clears 4.5:1 (WCAG 1.4.3) here.
                            color: colorByAreaKey?.[areaKey] ? "#fff" : undefined,
                        }}
                    >
                        <div style={{ fontWeight: 600 }}>{label}</div>
                        <div>
                            {formatNumberToTwoDecimals(numericValue)} {EMISSIONS_UNIT}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};
